



























































































import { Component, Vue } from "vue-property-decorator";
import request from "@/api/lianmeng/index";
import NewsItem from "@/components/NewsItem.vue";
import CommentItem from "@/components/CommentItem.vue";
import VueQr from "vue-qr";
import { List, Overlay, Loading } from "vant";
import native from "@/common/Native";
import domtoimage from "dom-to-image";
import { Base64 } from "js-base64";
import { IGraphicPage, ICommonItem } from "@/api/lianmeng/types";
import { toRem } from "@/common/Utils";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    NewsItem,
    CommentItem,
    VueQr,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [List.name]: List
  }
})
export default class GraphicPage extends Vue {
  detail: IGraphicPage | null = null;
  newsList: ICommonItem[] = [];
  infoClassifyId = "";
  lastCommonItem!: ICommonItem;
  commentList: ICommonItem[] = [];
  loading = false;
  finished = false;
  showLoading = false;
  showPoster = false;
  posterImg = "";
  get toRem() {
    return toRem;
  }

  get qrCodeText() {
    return location.href;
  }
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
  }
  async mounted() {
    this.infoClassifyId = this.$route.query.cid as string;
    this.$store.commit("SET_STATE", {
      appId: this.$route.query.appId
    });
    await this.getDetail();
    await this.getCommentList();
    await this.getNewsList();
    this.$nextTick(() => {
      (window as any).generateImg = this.generateImg;
    });
  }

  async getDetail() {
    const result = await request.getInfoDetailNew(this.infoClassifyId);
    if (result.code === 0) {
      this.detail = result.data;
      this.$nextTick(() => {
        // 埋点
        this.endTime = time();
        if (this.dataSource) {
          getData(this.startTime, this.endTime, this.detail);
          this.dataSource = false;
        }
      });
    }
  }

  /**热点列表 */
  async getNewsList() {
    const result = await request.getHotList(this.infoClassifyId);
    if (result.code >= 0) {
      this.newsList = result.data.dataList;
    }
  }

  async getCommentList() {
    const lastItem = this.lastCommonItem || {};
    const result = await request.getCommentListByPage(
      this.detail!.id + "",
      "1",
      lastItem.createTime,
      lastItem.replyId
    );
    if (result.code >= 0) {
      if (result.data.dataList.length === 0) {
        this.finished = true;
      } else {
        this.commentList = this.commentList.concat(result.data.dataList);
        this.loading = false;
        this.lastCommonItem = result.data.dataList.lastChild;
      }
    }
  }

  //跳转热点详情
  newItemClick(item: any) {
    if (native.isOpenInApp()) {
      native.openWebBrowser({
        id: item.id,
        sourceId: item.informationId,
        detailViewType: item.detailViewType,
        sourceType: item.sourceType,
        commentType: item.commentType,
        contextType: item.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "0",
        url: item.url,
        shareUrl: item.shareUrl,
        title: Base64.encode(item.title), //base 64
        synopsis: Base64.encode(item.synopsis), //base 64
        shareImgUrl: item.shareImgUrl,
        videoFormat: item.videoFormat ? item.videoFormat : ""
      });
    } else {
      window.location.href = item.url;
    }
  }

  savePoster() {
    // console.log(this.posterImg);
    native.savePoster(this.posterImg);
  }

  sharePoster() {
    native.sharePoster(this.posterImg);
  }

  generateImg() {
    this.showPoster = true;
    this.showLoading = false;
    this.$nextTick(() => {
      const poster = this.$refs.poster as HTMLElement;
      const img = this.$refs.posterImg as HTMLImageElement;
      const scale = 750 / poster.offsetWidth;
      const toImg = () => {
        domtoimage.toPng(poster).then(() => {
          domtoimage
            .toPng(poster, {
              height: poster.offsetHeight * scale,
              width: poster.offsetWidth * scale,
              style: {
                transform: "scale(" + scale + ")",
                transformOrigin: "top left",
                width: poster.offsetWidth + "px",
                height: poster.offsetHeight + "px"
              }
            })
            .then((result: string) => {
              this.posterImg = result;
              this.showLoading = false;
            });
        });
      };
      if (img.complete) {
        toImg();
      } else {
        img.onload = () => {
          toImg();
        };
      }
    });
  }

  toLink() {
    window.open(
      "http://h5cloud.cqliving.com/showtest/april-launch/#/blockchain-certificate"
    );
  }

  onLoad() {
    this.getCommentList();
  }
}
